import { PageKeyMap, PageLoadedSelectorsMap } from '@/telemetry-sdk';

const pageKeyMap: PageKeyMap = {
  homepage: '/',
};

const pageLoadedSelectorsMap: PageLoadedSelectorsMap = {
  homepage: ['[data-testid="masthead-main-bar"]', '.banner-container', '[data-testid="menu-tile-image"]'],
};

export { pageKeyMap, pageLoadedSelectorsMap };
